import { render, staticRenderFns } from "./National.vue?vue&type=template&id=055554d8&scoped=true"
import script from "./National.vue?vue&type=script&lang=js"
export * from "./National.vue?vue&type=script&lang=js"
import style0 from "./National.vue?vue&type=style&index=0&id=055554d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055554d8",
  null
  
)

export default component.exports